import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import "./users.css";
import axios from "axios";
import swal from "sweetalert";
import { t } from "i18next";
import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function BankOut() {
    function formatDate(m) {
        if (!m) return "";
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }
    const [data, setData] = useState(null);
    const [data2, setData2] = useState(null);
    const [load, setLoad] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [balance, setBalance] = useState({ prince: 0, v8: 0, payspec: 0 });
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        if (load === false) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/payment/chuyentien`, {})
                .then((res) => {
                    setData(res.data.data);
                    setData2(res.data.data);
                    setLoad(true);
                })
                .catch((err) => setLoad(true));
            axios
                .get(`${process.env.REACT_APP_API_URL}/bank/balance`, {})
                .then((res) => {
                    if (res.data.data) {
                        const prince = res.data.data.princepay !== undefined ? res.data.data.princepay : (res.data.data.result?.points || 0);
                        const v8 = res.data.data.v8pay !== undefined ? res.data.data.v8pay : 0;
                        const payspec = res.data.data.payspec !== undefined ? res.data.data.payspec : 0;
                        setBalance({ prince, v8, payspec });
                    }
                    setLoading(false);
                })
                .catch(() => setLoading(false));
        }
    }, [load]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (load === true) {
            const formData = {
                name: e.target.name.value,
                amount: e.target.amount.value,
                bank_id: e.target.type.value,
                bank_account: e.target.bank_account.value,
                bank_no: e.target.bank_no.value
            };
            setLoading(true);
            axios
                .post(`${process.env.REACT_APP_API_URL}/bank/bankout`, formData)
                .then((res) => {
                    setLoad(false);
                    swal(t('success'), "", "success");
                    setLoading(false);
                })
                .catch((res) => {
                    setLoad(false);
                    swal(t('error'), "", "error");
                    setLoading(false);
                });
        }
    };

    const [pages, setPage] = useState(1);
    const handleChange = (e, page) => {
        setPage(page);
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    {profile?.permission?.full === 1 || profile?.isReadOnly || profile?.permission?.readonly == 1 ? (
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 1
                            }}>
                            {isLoading ? (
                                <div className="loading" style={{ maxWidth: "100%" }}>
                                    <div className="loader"></div>
                                </div>
                            ) : null}
                            <Container maxWidth={false}>
                                <div style={{ fontSize: "25px", fontWeight: 700 }}>Chuyển khoản</div>
                                <div style={{ color: "#f00", marginBottom: "15px", display: "flex", gap: "25px", flexWrap: "wrap" }}>
                                    <div>Số dư Princepay: <b>{Number(balance?.prince || 0).toLocaleString("vi-VN")} VNĐ</b></div>
                                    <div>Số dư V8PAY: <b>{Number(balance?.v8 || 0).toLocaleString("vi-VN")} VNĐ</b></div>
                                    <div>Số dư Payspec: <b>{Number(balance?.payspec || 0).toLocaleString("vi-VN")} VNĐ</b></div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0 50px" }}>
                                    <form onSubmit={handleSubmit}>
                                        <div>
                                            <div style={{ width: "400px", marginBottom: "20px" }}>
                                                <label>Tên nhân vật</label>
                                                <input type="text" name="name" id="name" className="input_setting" required />
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ width: "400px", marginBottom: "20px" }}>
                                                <label style={{ marginRight: "10px" }}>Chọn ngân hàng</label>
                                                <select name="type" id="type" required>
                                                    <option value="MBBANK">MBBANK</option>
                                                    <option value="OCB">OCB</option>
                                                    <option value="VIB">VIB</option>
                                                    <option value="ACB">ACB</option>
                                                    <option value="DONGABANK">DONGABANK</option>
                                                    <option value="Eximbank">Eximbank</option>
                                                    <option value="BIDV">BIDV</option>
                                                    <option value="VietinBank">VietinBank</option>
                                                    <option value="AGRIBANK">AGRIBANK</option>
                                                    <option value="Vietcombank">Vietcombank</option>
                                                    <option value="Techcombank">Techcombank</option>
                                                    <option value="TPBANK">TPBANK</option>
                                                    <option value="SACOMBANK">SACOMBANK</option>
                                                    <option value="HDBANK">HDBANK</option>
                                                    <option value="MARITIMEBANK">MARITIMEBANK</option>
                                                    <option value="OCEANBANK">OCEANBANK</option>
                                                    <option value="SHB">SHB</option>
                                                    <option value="SEABANK">SEABANK</option>
                                                    <option value="VPBANK">VPBANK</option>
                                                    <option value="ABBANK">ABBANK</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ width: "400px", marginBottom: "20px" }}>
                                                <label>Tên tài khoản ngân hàng</label>
                                                <input type="text" name="bank_account" id="bank_account" className="input_setting" required />
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ width: "400px", marginBottom: "20px" }}>
                                                <label>Số tài khoản ngân hàng</label>
                                                <input type="text" name="bank_no" id="bank_no" className="input_setting" required />
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ width: "400px", marginBottom: "20px" }}>
                                                <label>Số điểm</label>
                                                <input type="number" name="amount" id="amount" className="input_setting" required />
                                            </div>
                                        </div>
                                        <button className="btn_setting">{t('submit')}</button>
                                    </form>
                                </div>
                                <div className="container_set">Lịch sử giao dịch</div>
                                <div className="form_set">
                                    <Box>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ padding: "10px" }}>Người thực hiện</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>Chi tiết</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>Số điểm</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>Trạng thái</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>Ngân hàng</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>STK</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>Tên TK</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>Thời gian</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data && data.length > 0 ? (
                                                    data.slice((pages - 1) * 10, pages * 10).map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ padding: "10px" }}>{item.admin_name || item.name}</TableCell>
                                                            <TableCell sx={{ padding: "10px" }}>{item.description || item.note || "-"}</TableCell>
                                                            <TableCell sx={{ padding: "10px" }}>{Math.floor((item?.money || item?.amount || 0) / 1000).toLocaleString("vi-VN")}</TableCell>
                                                            <TableCell sx={{ padding: "10px" }}>
                                                                {item?.status_payment === "Success" ? (
                                                                    <span className="badge success">Thành công</span>
                                                                ) : item?.status_payment === "Pending" ? (
                                                                    <span className="badge warning">Đang xử lý</span>
                                                                ) : (
                                                                    <span className="badge danger">Thất bại</span>
                                                                )}
                                                            </TableCell>
                                                            <TableCell sx={{ padding: "10px" }}>{item.bank_id || item.bank_name || "-"}</TableCell>
                                                            <TableCell sx={{ padding: "10px" }}>{item.bank_no || "-"}</TableCell>
                                                            <TableCell sx={{ padding: "10px" }}>{item.bank_account || "-"}</TableCell>
                                                            <TableCell sx={{ padding: "10px" }}>{item.createdAt ? formatDate(new Date(item.createdAt)) : "-"}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : null}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                    {data && data.length > 0 ? (
                                        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                            <Pagination count={Math.ceil(data.length / 10)} page={pages} onChange={handleChange} color="primary" />
                                        </Box>
                                    ) : null}
                                </div>
                            </Container>
                        </Box>
                    ) : (
                        <Box sx={{ p: 3 }}>Không có quyền truy cập</Box>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default BankOut;
